<template>
    <div class="text-left">
        <div class="row">
            <div class="col col-sm-12">
                <h3 class="font-weight-bolder mt-2">Address & Contact Details</h3>

                <div class="card">

                    <div class="card-body text-small">
                        <div class="row">
                            <div class="col col-sm-6">
                                <crew-address></crew-address>
                            </div>
                            <div class="col col-sm-5 offset-1">
                                <contact-details></contact-details>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { vueAppMixin } from "../../../../../../mixins/vueAppMixin";

    import CrewAddress from "./crew_contacts/CrewAddress";
    import ContactDetails from "./crew_contacts/ContactDetails";

    export default {
        name: "CrewContact",
        mixins: [ vueAppMixin ],

        components: {
            CrewAddress,
            ContactDetails
        },
    }
</script>

<style scoped>

</style>
